import { upsertUser } from '@dispatch/shared/services';
import { CreateUserPost } from '@dispatch/shared/types';
import { useMutation, useQueryClient } from 'react-query';

export const useUpsertUser = (
  userId: string,
  onSuccess: ({ success }: { success: boolean; message?: string }) => void
) => {
  const client = useQueryClient();
  const { mutate, error, status } = useMutation(
    ['upsert-user', userId],
    async (data: Partial<CreateUserPost>) => upsertUser(data),
    {
      onSuccess,
      onSettled: () => {
        if (userId) {
          client.invalidateQueries(['upsert-user', userId]);
          client.invalidateQueries('upsert-user');
        }
      },
    }
  );

  return {
    upsertUser: mutate,
    error,
    status,
  };
};
